import React, { useEffect, useState } from 'react';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo } from '../../../components/DataTable/Interfaces';
import { useNotifications } from '../../../contexts/notificationContext';
import ProjectItemRevisionModel from '../../../models/ProjectItemRevisionModel';
import ProjectMilestoneModel from '../../../models/ProjectMilestoneModel';
import DataService from "../../../services/data.service";
import { ProjectProps } from '../../../types/IdProps';

interface MilestoneTabProps extends ProjectProps {
    milestones: ProjectMilestoneModel[]
}

const Project_tab_Milestones: React.FC<MilestoneTabProps> = ({ projectId, projectTypeId, milestones, refreshDataCounter }) => {
    const [data, setData] = useState<ProjectItemRevisionModel[]>();
    const { handleException } = useNotifications();

    useEffect(() => {
        getTableData();
    }, [projectId, refreshDataCounter]);

    function getTableData() {
        DataService.get<ProjectItemRevisionModel[]>('api/v1/ProjectItemRevisions/ByProjectWithMilestones/' + projectId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    let colInfos: IColInfo[] = [
        { key: true, dataProp: 'itemRevisionId', visible: false },
        { title: 'Item Nr', dataProp: 'itemRevision.item', dataType: 'item', sort: 'asc' },
        { title: 'Revision', dataProp: 'itemRevision.revisionNumber', filterInfo: { filterType: 'CheckboxList' } },
    ];
    milestones.forEach(x => {
        if (x.milestoneTypeId != 1) {
            colInfos.push({
                title: x.milestoneName,
                dataProp: x.milestoneName,
                dataType: 'date',
                getCellData: getCellData,
                getCellBackgroundColor: getCellColor
            });
        }
    });

    function getCellData(projectItemRevision: ProjectItemRevisionModel, colInfo: IColInfo) {
        let value: string | undefined;
        if (projectItemRevision.milestones)
            projectItemRevision.milestones.forEach(x => {
                if (x.milestoneName == colInfo.dataProp)
                    value = x.achievedOn;
        });
        return value;
    }

    function getCellColor(projectItemRevision: ProjectItemRevisionModel, colInfo: IColInfo) {
        let value: string = '';
        if (projectItemRevision.milestones)
            projectItemRevision.milestones.forEach(x => {
                if (x.milestoneName == colInfo.dataProp)
                    value = x.color;
        });
        return value;
    }

    return (
        <>
            <DataTable
                name='dtProjectMilestones'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Itemrevision'
                navigateUrl='/plm/Items/ItemRevision/'
            />
        </>
    );
}
export default Project_tab_Milestones;